import {gql} from '@apollo/client';
import {PICKUP_TASK_APPOINTMENT_FIELDS, PickupAppointmentType} from '../types/PickupTaskWithAppointmentsType';

export const GET_PUBLISHED_TASK_BY_DRIVER = gql`
  query GetPublishedTaskByDriver {
    getPublishedTaskByDriver {
      ...PickupTaskAppointmentFields
    }
  }
  ${PICKUP_TASK_APPOINTMENT_FIELDS}
`;

export interface GetPublishedTaskResponse {
  getPublishedTaskByDriver: PickupAppointmentType[];
}